export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'lanmei', name: '蓝莓视频', icon: 'ri-movie-line' },
  { slug: 'tangxin', name: '糖心视频', icon: 'ri-heart-line' },
  { slug: 'heitao', name: '黑桃视频', icon: 'ri-vip-diamond-line' },
  { slug: 'yaojing', name: '妖精视频', icon: 'ri-magic-line' },
  { slug: 'dongzuo', name: '动作大片', icon: 'ri-fire-line' },
  { slug: 'juqing', name: '剧情精选', icon: 'ri-emotion-line' },
  { slug: 'xiju', name: '喜剧搞笑', icon: 'ri-emotion-happy-line' },
  { slug: 'kongbu', name: '悬疑惊悚', icon: 'ri-ghost-line' },
  { slug: 'aiqing', name: '爱情浪漫', icon: 'ri-heart-2-line' },
  { slug: 'kehuan', name: '科幻巨制', icon: 'ri-rocket-line' },
  { slug: 'jilu', name: '纪录纪实', icon: 'ri-camera-line' },
];

export const categoryInfo: Record<string, { title: string; description: string; keywords: string }> = {
  all: {
    title: '全部视频 - 51视频 | 高清蓝光4K免费在线观看',
    description: '51视频全部视频资源，涵盖蓝莓视频、糖心视频、黑桃视频、妖精视频等品牌，蓝光4K超清画质，无广告不缓冲，免费在线观看。',
    keywords: '51视频,全部视频,高清,蓝光,4K',
  },
  lanmei: {
    title: '蓝莓视频 - 51视频 | 蓝光4K超清无广告免费在线观看',
    description: '蓝莓视频专区，51视频旗下品牌之一，提供海量蓝光4K超清视频资源，播放流畅不缓冲，无广告打扰，免费在线观看。',
    keywords: '蓝莓视频,51视频,高清,蓝光,4K,超清',
  },
  tangxin: {
    title: '糖心视频 - 51视频 | 蓝光4K超清无广告免费在线观看',
    description: '糖心视频专区，51视频旗下品牌之一，精选优质高清视频内容，蓝光4K超清画质，无广告不缓冲，免费在线观看。',
    keywords: '糖心视频,51视频,高清,蓝光,4K,超清',
  },
  heitao: {
    title: '黑桃视频 - 51视频 | 蓝光4K超清无广告免费在线观看',
    description: '黑桃视频专区，51视频旗下品牌之一，汇聚热门高清视频资源，蓝光4K超清体验，无广告不缓冲，免费在线观看。',
    keywords: '黑桃视频,51视频,高清,蓝光,4K,超清',
  },
  yaojing: {
    title: '妖精视频 - 51视频 | 蓝光4K超清无广告免费在线观看',
    description: '妖精视频专区，51视频旗下品牌之一，提供丰富多样的高清视频内容，蓝光4K超清画质，无广告不缓冲，免费在线观看。',
    keywords: '妖精视频,51视频,高清,蓝光,4K,超清',
  },
  dongzuo: {
    title: '动作大片 - 51视频 | 蓝光4K超清无广告免费在线观看',
    description: '动作大片专区，精选高分动作影片，蓝光4K超清画质，肾上腺素飙升的视觉盛宴，无广告不缓冲，免费在线观看。',
    keywords: '动作大片,动作电影,51视频,高清,蓝光,4K',
  },
  juqing: {
    title: '剧情精选 - 51视频 | 蓝光4K超清无广告免费在线观看',
    description: '剧情精选专区，精选国内外优秀剧情影片，蓝光4K超清画质，感人至深的故事演绎，无广告不缓冲，免费在线观看。',
    keywords: '剧情精选,剧情电影,51视频,高清,蓝光,4K',
  },
  xiju: {
    title: '喜剧搞笑 - 51视频 | 蓝光4K超清无广告免费在线观看',
    description: '喜剧搞笑专区，汇集爆笑喜剧影片，蓝光4K超清画质，欢乐不断笑声不停，无广告不缓冲，免费在线观看。',
    keywords: '喜剧搞笑,喜剧电影,51视频,高清,蓝光,4K',
  },
  kongbu: {
    title: '悬疑惊悚 - 51视频 | 蓝光4K超清无广告免费在线观看',
    description: '悬疑惊悚专区，精选高分悬疑惊悚影片，蓝光4K超清画质，紧张刺激的观影体验，无广告不缓冲，免费在线观看。',
    keywords: '悬疑惊悚,恐怖电影,51视频,高清,蓝光,4K',
  },
  aiqing: {
    title: '爱情浪漫 - 51视频 | 蓝光4K超清无广告免费在线观看',
    description: '爱情浪漫专区，精选浪漫爱情影片，蓝光4K超清画质，甜蜜温馨的观影体验，无广告不缓冲，免费在线观看。',
    keywords: '爱情浪漫,爱情电影,51视频,高清,蓝光,4K',
  },
  kehuan: {
    title: '科幻巨制 - 51视频 | 蓝光4K超清无广告免费在线观看',
    description: '科幻巨制专区，精选视觉震撼的科幻大片，蓝光4K超清画质，未来世界的无限想象，无广告不缓冲，免费在线观看。',
    keywords: '科幻巨制,科幻电影,51视频,高清,蓝光,4K',
  },
  jilu: {
    title: '纪录纪实 - 51视频 | 蓝光4K超清无广告免费在线观看',
    description: '纪录纪实专区，精选优质纪录片，蓝光4K超清画质，真实世界的深度探索，无广告不缓冲，免费在线观看。',
    keywords: '纪录纪实,纪录片,51视频,高清,蓝光,4K',
  },
};